module.exports = "img/chevron-right.0070bb4.png";